<template>
  <div class="text-center pb-1" v-if="buildingDetailLoading">
    <double-bounce></double-bounce>
  </div>
  <div v-else>
    <v-card v-if="buildingDetailShow" class="mx-auto mb-5" max-width="400" tile>
      <v-img
        src="../assets/tmn.png"
        v-if="buildingDetail.photos.data.length == 0"
        aspect-ratio="1.7"
      ></v-img>
      <v-carousel v-else height="180" cycle :show-arrows="false">
        <v-carousel-item
          v-for="(key, i) in buildingDetail.photos.data"
          :key="i"
          :src="key.full_path"
        ></v-carousel-item>
      </v-carousel>
      <v-list-item style="background-color: #a9a9a9">
        <v-list-item-content>
          <v-list-item-title>
            <h3 class="pb-2 white--text">
              {{ buildingDetail.building_name }}
            </h3>
            <v-chip label color="white">{{
              buildingDetail.building_grade
            }}</v-chip>
            <p style="white-space: normal;" class="pt-2 mb-0 white--text">
              {{ buildingDetailAddress }}
            </p>
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item two-line>
        <v-list-item-content>
          <v-list-item-title>Building Type :</v-list-item-title>
          <v-list-item-subtitle>
            {{ buildingDetail.building_type || "-" }}
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-list-item two-line v-if="reporting == false">
        <v-list-item-content>
          <v-list-item-title
            >Last Renovated / Completion Year</v-list-item-title
          >
          <v-list-item-subtitle>
            {{ buildingDetail.last_renovated || "-" }}
            /
            {{ buildingDetail.completion_year || "-" }}
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-list-item two-line>
        <v-list-item-content>
          <v-list-item-title>Floor count :</v-list-item-title>
          <v-list-item-subtitle>
            {{ buildingDetail.no_of_floors || "-" }}
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-list-item two-line>
        <v-list-item-content>
          <v-list-item-title>Size / No of Units :</v-list-item-title>
          <v-list-item-subtitle>
            {{ buildingDetail.units || "-" }}
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-list-item two-line v-if="!reporting">
        <v-list-item-content>
          <v-list-item-title>Screen Presence :</v-list-item-title>
          <v-list-item-subtitle
            v-if="buildingDetail.job_detail_info.length < 1"
          >
            -
          </v-list-item-subtitle>
          <v-list-item-subtitle
            v-else
            v-for="(key, i) in buildingDetail.job_detail_info"
            :key="i"
          >
            {{
              key.screen.screen_size_name + " " + key.screen.screen_point_name
            }}
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-list-item two-line v-else>
        <v-list-item-content>
          <v-list-item-title>Total Screen :</v-list-item-title>
          <v-list-item-subtitle>
            {{ totalScreen || "-" }}
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-list-item two-line v-if="!reporting">
        <v-list-item-content>
          <v-list-item-title>Progress :</v-list-item-title>
          <v-list-item-subtitle>
            {{ buildingDetail.status || "-" }}
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-list-item two-line v-else>
        <v-list-item-content>
          <v-list-item-title>Audience :</v-list-item-title>
          <v-list-item-subtitle>
            {{ audience }}
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-list-item eight-line v-if="!reporting">
        <v-list-item-content>
          <v-list-item-title>Instalation :</v-list-item-title>
          <v-list-item-subtitle>
            {{ buildingDetail.installation || "-" }}
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-list-item eight-line v-else>
        <v-list-item-content>
          <v-list-item-title>Impression :</v-list-item-title>
          <v-list-item-subtitle>
            {{ impression || "-" }}
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-btn
        color="error"
        depressed
        block
        small
        @click="buildingDetailShow = false"
      >
        close
      </v-btn>
    </v-card>
  </div>
</template>

<script>
import axios from "axios";
import { DoubleBounce } from "vue-loading-spinner";
import { EventBus } from "@/utils/eventBus";
import { getToken } from "../utils/auth";

export default {
  components: {
    DoubleBounce
  },
  name: "BuildingDetail",
  mounted() {
    if (getToken("role") == 12) {
      this.reporting = true;
    }
  },
  data() {
    return {
      buildingDetailLoading: false,
      buildingDetailShow: false,
      buildingDetailAddress: "",
      buildingDetail: [],
      reporting: false,
      totalScreen: 0,
      audience: 0,
      impression: ""
    };
  },
  created() {
    EventBus.$on("TYPE_DETAIL_BUILDING", value => {
      this.detailBuilding(value.building_id, value.address);
      this.buildingDetailLoading = true;
      this.buildingDetailShow = true;
    });
  },
  methods: {
    async detailBuilding(id, address) {
      let url = `${process.env.VUE_APP_API_URL}/api/admin/building/${id}`;
      let headers = {
        "Content-Type": "application/json",
        Authorization: "Bearer " + getToken("api_token")
      };

      await axios
        .get(url, {
          headers: headers
        })
        .then(result => {
          this.buildingDetailAddress = address;
          this.buildingDetail = result.data.data.data;
          this.buildingDetailLoading = false;
          this.impression = result.data.data.data.impression;
          this.audience = result.data.data.data.audience_actual;
          this.totalScreen = result.data.data.data.ordered;
        })
        .catch(err => {
          throw new Error(err);
        });
    }
  }
};
</script>
